import { Coupon } from '../coupon'
import { ButtonPanelPage } from '../../buttonPanelPage'
import { SpaceLoader } from '../../../../loaders/spaceLoader'
import { useDispatch } from 'react-redux'
import { useCouponAndModalForms } from '../couponAndModalFormsContext'
import { ModalForms } from '../../modalForms'
import { toast } from 'react-toastify'

import { Container, CouponsContainer, ButtonFixedContainer } from './style'

export function CouponsContent() {
    const { isLoading, coupons, franchiseListCodesSelected,isCouponAreaVisible} = useCouponAndModalForms()
    const dispatch = useDispatch()


    function handleOpenModal() {
        if(!isCouponAreaVisible && franchiseListCodesSelected.length > 1){
            toast.info('Por favor, selecione somente uma franquia !');
            return
        }

        if(!isCouponAreaVisible && franchiseListCodesSelected.length <= 0){
            toast.info('Por favor, selecione alguma franquia !');
            return
        }

        dispatch({type: 'OPEN_MODALFORMS_CREATE', title: 'Novo Cupom'})
    }
    
    
    return(
        <Container > 

                <div className="fill"></div>

                <CouponsContainer>
                    
                    {isLoading ?
                        <SpaceLoader colorLoader="gray"/> 
                        :
                        coupons.map(coupon => (
                            <Coupon key={coupon.idCoupon} couponDatas={coupon} />
                        ))
                        // isCouponAreaVisible ?
                        //     coupons.map(coupon => (
                        //         <Coupon key={coupon.idCoupon} couponDatas={coupon} />
                        //     ))
                        //     : 
                        //     <p>Selecione somente uma empresa</p>
                    }
                    
                    <ButtonFixedContainer>
                        <ButtonPanelPage 
                            label={"Novo Cupom"} 
                            svg={true} 
                            handleClickButton={handleOpenModal}  
                        />
                    </ButtonFixedContainer>
                  

                </CouponsContainer>
                
                <ModalForms />
        </Container>
    )
}